<template>
  <div
    class="widget"
    :class="{
      'flatten': flattenWidget,
      ['without-footer']: withoutFooter,
      ['without-title']: withoutTitle,
      'with-size': widgetSize,
      [widgetWrapperName]: widgetWrapperName,
      'width-fixed': widgetWidthFixed
    }"
  >
    <template v-if="isPending">
      <spinner style="margin: auto" />
    </template>
    <template v-else-if="isError">
      <error-banner
        :label="error.label"
        :txt="error.txt"
        :isTest="error.isTest"
        :testField="error.testField"
      />
    </template>
    <template v-else-if="routeName === 'Home'">
      <home-page :hasExtUserId="hasExtUserId" />
    </template>

    <template v-else>
      <router-view class="child-wrapper" />
      <router-view :name="routerViewComponent" />
    </template>
  </div>
</template>


<!--pm2 serve . 8888-->
<!--pm2 kill-->

<!--http://localhost:3499/5d076f31-519f-4733-93ae-cbe5d1213594/payin-fiat?extUserId=12345 или 0ac52ac0-859a-49e8-bd7d-d88fed889d0 fiat -->
<!--http://localhost:3499/5d076f31-519f-4733-93ae-cbe5d1213594/payin-crypto?extUserId=12345 или 0ac52ac0-859a-49e8-bd7d-d88fed889d0 invoice -->
<!--http://localhost:3499/0ac52ac0-859a-49e8-bd7d-d88fed889d03?accentColor=purple&wrapper=medium&width=fixed   - инвойс -->
<!--http://localhost:3499/ec775639-adf0-4234-b4b0-403604dc320c?accentColor=purple&width=fixed&extUserId=test   - персонал -->
<!--http://localhost:3499/3b488088-fba3-407c-870d-11b2b9f96393?accentColor=purple&width=fixed&extUserId=виджВыплат&payoutCryptoCurrenciesFrom=USD&payoutCryptoAmountFrom=200   - выплаты -->
<!--http://localhost:3499/0024de78-fb51-4517-bd07-14f936516e9d?accentColor=purple&width=fixed&extUserId=виджВыплат&payoutCryptoCurrenciesFrom=USD&payoutCryptoAmountFrom=200   - выплаты -->

<script>
import axios from "axios";
import { mapState, mapMutations, mapGetters } from "vuex";

import { v4 as UUID } from "uuid";

export default {
  name: "Main",
  data() {
    return {
      apiKey: null,

      description: null,
      currency: null,
      network: null,
      amount: null,

      pending: false,
      error: {
        label: 'Error',
        txt: '',
        isTest: false,
        testField: '',
      },
      paymentMethod: null,
      paymentEmail: null,

      clientEmail: '',

      baseInfo: null,
      orderInfo: null,
      query: '',
      timeIsOver: false,
    };
  },
  components: {
    HomePage: () => import(/* webpackChunkName: "entries/widget/page/Home" */ '@/entries/widget/page/Home'),

    Spinner: () => import(/* webpackChunkName: "entries/iframe-order/components/Spinner" */ '@/entries/widget/components/Spinner'),
    ErrorBanner: () => import(/* webpackChunkName: "entries/widget/components/Errors/error" */ '@/entries/widget/components/Errors/error')
  },
  computed: {
    ...mapState([
      'showStartPage', 'payinCrypto', 'payoutCrypto', 'payinCryptoType', 'theme', 'widgetSize', 'withoutFooter', 'withoutTitle', 'widgetHeight', 'widgetWidth', 'lang'
    ]),
    routeName({ $route }) {
      return $route.name
    },
    extUserId({ $route }) {
      return $route.query.extUserId
    },
    hasExtUserId({ extUserId }) {
      return !!extUserId
    },
    routerViewComponent({ $route, payinCryptoType }) {
      const { name } = $route

      if ( name === 'PayinCrypto' && !!payinCryptoType ) {
        return payinCryptoType.toLowerCase()
      } else if ( name === 'PayoutCrypto' ) {
        return 'payout'
      } else if ( name === 'PayinFiat' ) {
        return 'fiat'
      } else {
        return undefined
      }
    },
    queries() {
      let { search } = window.location;
      search = (search + '').substring(1);
      return new URLSearchParams(search)
    },
    isApollo() {
      const { host } = location
      return host.includes('apollo')
    },
    hasWidgetId({ widgetId }) {
      return !!widgetId && !['payin-crypto', 'payout-crypto', 'payin-fiat'].includes(widgetId)
    },
    widgetId({ $route }) {
      return $route.params.widgetId
    },
    isPending() {
      if (!this.widgetId) {
        return false;
      }

      if(this.isError) {
        return false;
      }

      return this.pending;
    },
    isError() {
      return !!this.error.txt;
    },
    isMethodSelected() {
      return !!this.paymentMethod;
    },
    isEmailEntered() {
      return !!this.paymentEmail;
    },
    orderId({ $route }) {
      const { payinCryptoInvoiceId } = $route.query

      return payinCryptoInvoiceId || UUID();
    },
    payoutId({ $route }) {
      const { payoutId } = $route.query

      return payoutId || UUID();
    },
    fiatId({ $route }) {
      const { fiatId } = $route.query

      return fiatId || UUID()
    },
    orderAmount() {
      return this.query.get('amount')
    },
    emailValid({ clientEmail }) {
      const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return regExp.test(clientEmail)
    },
    canMakePayment({ baseInfo }) {
      return baseInfo.canPayment
    },
    isStatusSuccess({ orderInfo }) {
      return orderInfo.status === 'overpaid' || orderInfo.status === 'processed'
    },
    widgetWithoutTitle({ $route }) {
      return $route.query.withoutTitle
    },
    widgetWithoutTransactions({ $route }) {
      return $route.query.withoutTransactions
    },
    flattenWidget({ widgetWithoutTitle, widgetWithoutTransactions }) {
      return widgetWithoutTitle && widgetWithoutTransactions
    },
    widgetWrapperName({ $route }) {
      return $route.query.wrapper
    },
    isBet4slotWrapper({ widgetWrapperName }) {
      return widgetWrapperName === 'small'
    },
    widgetWidthFixed({ $route }) {
      return $route.query.width === 'fixed'
    }
  },
  created() {
    if (!this.theme) {
      const isApollo = window.location.host.includes('apollo')

      const themeAttributeName = isApollo ? 'widget-theme-apollo' : 'widget-theme'
      // пока не получили тему с бэка, пытаемся угадать ее через window.matchMedia
      const themeOsDark = window.matchMedia("(prefers-color-scheme: dark)")
      if (themeOsDark.matches) {
        document.documentElement.setAttribute(themeAttributeName, 'dark')
      }

      const themeOsLight = window.matchMedia("(prefers-color-scheme: light)")
      if (themeOsLight.matches) {
        document.documentElement.setAttribute(themeAttributeName, 'light')
      }
    }

    this.setWidgetSizes()
  },
  async mounted() {
    if (!this.lang) {
      const { queries } = this
      this.setLanguage(queries.get('lang') || 'en')
    }

    await this.getWidgetParams()

    if (this.payinCryptoType === 'PERSONAL' && this.hasExtUserId) {
      await this.getPersonalUserInfo()
    }
  },
  methods: {
    ...mapMutations( ['setMainParamsFromBack', 'setPersonalUserInfo', 'setWidgetSizes', 'setLanguage'] ),
    async getWidgetParams() {
      if (!!this.payinCryptoType || !!this.payoutCrypto) return

      this.pending = true

      if (!this.$route.name) {
        setTimeout(async () => {
          await this.getWidgetParams()
        }, 200)
        return
      }

      return await axios.get('/public-api/iframe-widget/' + this.widgetId)
        .then((res) => {
          if (!res.data.success) {
            this.error.txt = res.data.error;
          } else if (res.data.success) {
            if (!res.data.result) {
              this.error.txt = 'Succeed response without data'
            } else {
              //check siteUrl
              const iframeUrl =  (window.location !== window.parent.location) ? document.referrer: null

              const { result } = res.data
              const { widget } = result || {}
              const { siteURL = '' } = widget

              const siteURLIncludeGoogle = siteURL.includes('google.com') // доп условие для проверки на siteURL

              if ( !siteURLIncludeGoogle && !!iframeUrl && !!siteURL && !iframeUrl.includes(siteURL) ) {
                this.error.label = '404'
                this.error.txt = this.$t('errors.404')

                return
              }

              const { $route, orderId, payoutId, fiatId } = this

              const urlAccentColor = this.$route.query.accentColor
              const isUrlAccentColorValid = !!urlAccentColor && ['purple', 'orange', 'green', 'red', 'yellow', 'blue', 'bet4slot', 'alphacasino', 'cashcasinohub'].includes(urlAccentColor)

              if ( widget?.accentColor || isUrlAccentColorValid ) {
                this.setAccent(isUrlAccentColorValid ? urlAccentColor : widget.accentColor)
              }

              // делаем туму темной для 'bet4slot', 'alphacasino', 'cashcasinohub' по дефолту и без возможности изменения
              if ( isUrlAccentColorValid && ['bet4slot', 'alphacasino', 'cashcasinohub'].includes(urlAccentColor) ) {
                result.widget.theme = 'dark'
              }

              const data = {
                organization: result.organization,
                ...result.widget,
                orderId,
                payoutId,
                fiatId
              }

              if (!this.hasWidgetId) {
                this.error.txt = this.$t('errors.wrong-widget-id')
              } else {
                if (data.payinCryptoType === 'PERSONAL' && !this.hasExtUserId) {
                  this.error = {
                    txt:'extUserId parameter not passed for Personal Addresses Widget',
                    isTest: true,
                    testField: '&extUserId=test'
                  }
                }

                const hasSecondStepParam = ['payin-crypto', 'payout-crypto'].some(path => $route.path.includes(path))
                if (!data.showStartPage && !hasSecondStepParam) {
                  this.error.txt = 'Not enough parameters'
                }
              }

              this.setMainParamsFromBack(data)
            }
          }
        })
        .catch(_ => {
          this.error.txt = 'Internal server error. Please retry later';
        })
        .finally(() => {
          this.pending = false;
        })
    },
    async getPersonalUserInfo() {
      try {
        const res = await axios.post('/public-api/iframe-widget/' + this.widgetId + '/payin/personal', {
          clientId: this.extUserId
        });

        if(!res.data.success) {
          this.error.txt = res.data.error;
        } else if (res.data.success) {
          if (!res.data.result) {
            this.error.txt = 'Succeed response without data'
          } else {
            const { result } = res.data
            this.setPersonalUserInfo(result)
          }
        }
      } catch (e) {
        this.error.txt = 'Internal server error. Please retry later';
      }
    },
    setAccent(accent) {
      document.documentElement.setAttribute('widget-accent', accent)
    }
  }
}
</script>

<style lang="scss">
  .main-body {
    background-color: var(--bg-background-primary);
  }
  .widget {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.with-size {
      background-color: var(--bg-background-iframe-secondary);
      border-radius: 10px;
    }

    overflow: hidden;
    width: 100%;
    display: flex;

    &.without-footer {
      .widget-footer-block {
        display: none;
      }
    }

    &.width-fixed {
      max-width: 700px;
      &.medium {
        max-width: 450px;
      }
      &.small {
        max-width: 350px;
      }
    }

    max-height: 838px;
    min-height: 838px;

    @media screen and (max-height: 838px) {
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }

    &.medium {
      max-height: 600px;
      min-height: 600px;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media screen and (max-height: 600px) {
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
    &.small {
      max-height: 500px!important;
      min-height: 500px!important;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media screen and (max-height: 500px) {
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }

    @include below_medium() {
      max-height: 600px!important;
      min-height: 600px!important;
    }
    @include below_small() {
      max-height: 500px!important;
      min-height: 500px!important;
    }

    &.child-wrapper {
      font-family: Gilroy;

      position: relative;
      top: unset;
      left: unset;
      transform: unset;

      width: 100%;

      overflow: hidden;
      border-radius: 10px;

      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      gap: 13px;

      color: var(--text-text-primary);

      padding: 20px 30px 0;

      &.medium {
        padding: 15px 15px 0;
      }
      &.small {
        padding: 8px 8px 0;
      }

      @include below_medium() {
        padding: 15px 15px 0;
      }
      @include below_small() {
        padding: 8px 8px 0!important;
      }
    }

    .wrong-statuses {
      padding-top: 30px;

      color: var(--ocp-0-100-error-error40);
      text-align: center;
    }
  }

  .email-form {
    height: 100%;
  }
</style>
